import { render, staticRenderFns } from "./showTypeList.vue?vue&type=template&id=52abca62&"
import script from "./showTypeList.vue?vue&type=script&lang=js&"
export * from "./showTypeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports